import { useLocation } from "react-router-dom";
import { IconTooltip } from "../../components/IconTooltip";
import { GeneratedAppIcon } from "../../components/GeneratedAppIcon";
import { LibraryPinIcon } from "../../components/LibraryPinIcon";
import { libraryItemPath } from "../../lib/library-listing";
import { useLibraryPins } from "../../lib/library-preferences";

export function LibraryPinnedShortcuts({
  userId,
  departmentIds,
  onOpen,
}: {
  userId: string | null;
  departmentIds: ReadonlySet<string>;
  onOpen: (spaceId: string, path: string) => void;
}) {
  const pins = useLibraryPins(userId);
  const { pathname } = useLocation();
  const items = pins.items.filter(
    (item) => pins.ids.has(item.id) && departmentIds.has(item.spaceId),
  );
  if (!items.length) return null;
  return (
    <div
      aria-label="Pinned Library files"
      data-testid="library-pinned-shortcuts"
      className="flex w-full flex-col items-center gap-3 border-t border-sidebar-border pt-4 pb-2"
    >
      {items.map((item) => {
        const path = libraryItemPath(item);
        const active = pathname === path.split("?")[0];
        return (
          <IconTooltip key={item.id} label={item.name} side="inline-end">
            <a
              href={path}
              aria-label={`Open ${item.name}`}
              aria-current={active ? "page" : undefined}
              data-pinned-artifact={item.id}
              className={`app-no-drag flex size-12 shrink-0 items-center justify-center rounded-xl outline-none transition-transform hover:-translate-y-0.5 motion-reduce:transform-none focus-visible:ring-2 focus-visible:ring-ring ${active ? "bg-sidebar-active" : ""}`}
              onClick={(event) => {
                if (
                  event.button !== 0 ||
                  event.metaKey ||
                  event.ctrlKey ||
                  event.shiftKey ||
                  event.altKey
                )
                  return;
                event.preventDefault();
                onOpen(item.spaceId, path);
              }}
            >
              <>
                {item.isApp ? (
                  <GeneratedAppIcon
                    userId={userId}
                    spaceId={item.spaceId}
                    artifactId={item.id}
                    size={48}
                  />
                ) : (
                  <LibraryPinIcon item={item} />
                )}
              </>
            </a>
          </IconTooltip>
        );
      })}
    </div>
  );
}
